import { render, staticRenderFns } from "./payment-type-argentea-giftcard-ali.vue?vue&type=template&id=4ad96fc6"
import script from "./payment-type-argentea-giftcard-ali.vue?vue&type=script&lang=js"
export * from "./payment-type-argentea-giftcard-ali.vue?vue&type=script&lang=js"
import style0 from "./payment-type-argentea-giftcard-ali.vue?vue&type=style&index=0&id=4ad96fc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports